
import { Component, Prop, Vue } from 'vue-property-decorator';
import i18n from '@/i18n/index';
import FooterButton from '@/components/FooterButton.vue';

export enum MessageType {
  None,
  Starting,
  Calibrate,
  Wait,
  DirectionLeft,
  DirectionRight,
  DirectionUp,
  DirectionDown,
  DirectionCenter,
  Complete
}

@Component({
  components: {
    FooterButton
  }
})
export default class FaceDirectionMessage extends Vue {
  @Prop({ type: String, default: '' })
  buttonText!: string;

  @Prop({ type: Number, default: MessageType.None })
  messageType!: MessageType;

  @Prop({ type: Boolean, default: true })
  enabled!: boolean;

  get message(): string {
    switch (this.messageType) {
      case MessageType.Starting:
        return i18n.tc('202309_465');

      case MessageType.Calibrate:
        return i18n.tc('202309_467');

      case MessageType.Wait:
        return i18n.tc('202309_466');

      case MessageType.DirectionLeft:
        return i18n.tc('202309_469');

      case MessageType.DirectionRight:
        return i18n.tc('202309_470');

      case MessageType.DirectionUp:
        return i18n.tc('202309_467');

      case MessageType.DirectionDown:
        return i18n.tc('202309_4705');

      case MessageType.DirectionCenter:
        return i18n.tc('202309_471');

      case MessageType.Complete:
        return i18n.tc('202309_4715');

      case MessageType.None:
      default:
        return '';
    }
  }

  get caution(): string {
    return this.$store.getters['auth/currentLanguageWarningMessage'];
  }

  get isStart(): boolean {
    return this.messageType === MessageType.Starting;
  }

  get isSuccess(): boolean {
    return this.messageType === MessageType.DirectionCenter || this.messageType === MessageType.Complete;
  }
}
